export default __webpack_public_path__ + "static/og-image-47c9150444c012fc8cbb61768089657c.png";